<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Edit Attribute Description</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="form">
        <fieldset>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Description</label>
                    <input class="mvd_form-control" type="text" name="restrictionDescription" formControlName="restrictionDescription">
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="false == form?.valid" [isLoading]="saving" btnText="Save" (clicked)="save()"></mvm-spinner-btn>
    </div>
</div>